/**
 * Authentication Forms Handler
 * Handles AJAX submission for login, registration, and comment forms
 * 
 * @since 3.7.0
 */

(function($) {
    'use strict';

    // Wait for DOM to be ready
    $(document).ready(function() {
        initAuthForms();
    });

    /**
     * Initialize authentication forms
     */
    function initAuthForms() {
        // Intercept submit button clicks BEFORE default handler with highest priority
        $(document).on('click', '.simple_form_container .submit-button', function(e) {
            const $button = $(this);
            const $container = $button.closest('.simple_form_container');
            
            // Check if this form is configured as an auth form
            const formId = parseInt($container.data('form-id'));
            const formType = getAuthFormType(formId);
            
            // console.log('Form ID:', formId, 'Auth Form Type:', formType);
            
            if (formType === 'login' || formType === 'registration') {
                // Auth form - prevent ALL default behaviors
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                handleAuthFormSubmit($container, formType);
                return false;
            } else if (formType === 'comment') {
                // Comment form - prevent ALL default behaviors
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                handleCommentFormSubmit($container);
                return false;
            }
            // If regular form, let default handler run (leads submission)
        });
        
        // Also intercept form submit events for auth forms
        $(document).on('submit', '.simple_form_container form', function(e) {
            const $form = $(this);
            const $container = $form.closest('.simple_form_container');
            const formId = parseInt($container.data('form-id'));
            const formType = getAuthFormType(formId);
            
            if (formType === 'login' || formType === 'registration' || formType === 'comment') {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
            }
        });
        
        // Handle WordPress comment form submissions
        $(document).on('submit', 'form.simpleform-comment-form', function(e) {
            e.preventDefault();
            const $form = $(this);
            const $container = $form.find('.simple_form_container').first();
            
            if ($container.length > 0) {
                handleCommentFormSubmit($container);
            }
        });
    }

    /**
     * Get auth form type based on form ID from settings
     */
    function getAuthFormType(formId) {
        // console.log('Checking form ID:', formId);
        
        // Check if front_end_data and auth_form_ids are available
        if (typeof front_end_data === 'undefined' || typeof front_end_data.auth_form_ids === 'undefined') {
            // console.log('Auth form IDs not available in front_end_data');
            return 'regular';
        }
        
        // Check if pro is active - if not, don't treat any forms as auth forms
        if (typeof front_end_data.isProActive === 'undefined' || !front_end_data.isProActive) {
            // console.log('Pro is not active - treating all forms as regular');
            return 'regular';
        }
        
        const authFormIds = front_end_data.auth_form_ids;
        // console.log('Auth Form IDs:', authFormIds);
        
        // Check if this form ID matches any configured auth form
        if (formId === authFormIds.wp_login || formId === authFormIds.wc_login) {
            // console.log('Matched as LOGIN form');
            return 'login';
        } else if (formId === authFormIds.wp_registration || formId === authFormIds.wc_registration) {
            // console.log('Matched as REGISTRATION form');
            return 'registration';
        } else if (formId === authFormIds.comment) {
            // console.log('Matched as COMMENT form');
            return 'comment';
        }
        
        // console.log('No match - treating as REGULAR form');
        return 'regular';
    }

    /**
     * Handle auth form (login/registration) submission
     */
    function handleAuthFormSubmit($container, formType) {
        // console.log('Handling ' + formType + ' form submission');
        
        // Check if front_end_data is available
        if (typeof front_end_data === 'undefined') {
            console.error('front_end_data is not defined!');
            showMessage($container, 'error', 'Configuration error. Please refresh the page.');
            return;
        }
        
        // console.log('AJAX URL:', front_end_data.admin_ajax);
        // console.log('Nonce:', front_end_data.nonce);
        
        // Check terms acceptance for registration
        if (formType === 'registration') {
            const $termsCheckbox = $container.find('input[name="terms"]');
            if ($termsCheckbox.length > 0 && !$termsCheckbox.is(':checked')) {
                showMessage($container, 'error', 'Please accept the terms and conditions to continue.');
                return;
            }
        }
        
        // Collect form data
        const formData = new FormData();
        const action = formType === 'registration' ? 'simpleform_wp_register' : 'simpleform_wp_login';
        
        // console.log('Action:', action);
        
        // Get all form inputs
        $container.find('input, select, textarea').each(function() {
            const $field = $(this);
            const name = $field.attr('name');
            if (name) {
                if ($field.attr('type') === 'checkbox') {
                    formData.append(name, $field.is(':checked') ? 'on' : 'off');
                } else {
                    formData.append(name, $field.val());
                }
            }
        });
        
        // Get form ID
        const formId = $container.data('form-id');
        
        // console.log('Form ID:', formId);
        
        // Add action and form ID
        formData.append('action', action);
        formData.append('form_id', formId);
        formData.append('nonce', front_end_data.nonce);
        
        // Log all form data
        // console.log('Form data being sent:');
        /* for (let pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        } */
        
        // Show loading state
        const $submitBtn = $container.find('.submit-button');
        const originalText = $submitBtn.text();
        $submitBtn.prop('disabled', true).text('Processing...');
        $container.addClass('submitting');
        
        // Submit via AJAX
        $.ajax({
            url: front_end_data.admin_ajax,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                $container.removeClass('submitting');
                $submitBtn.prop('disabled', false).text(originalText);
                
                if (response.success) {
                    // Show success message
                    showMessage($container, 'success', response.data.message);
                    
                    // Optionally save to leads if setting is enabled
                    // This happens on the backend via WordPressAuth.php
                    
                    // Clear form fields
                    $container.find('input[type="text"], input[type="password"], input[type="email"]').val('');
                    $container.find('input[type="checkbox"]').prop('checked', false);
                    
                    // Redirect if URL provided
                    if (response.data.redirect_url) {
                        setTimeout(function() {
                            window.location.href = response.data.redirect_url;
                        }, 1500);
                    } else {
                        // Reload page after 1.5 seconds
                        setTimeout(function() {
                            window.location.reload();
                        }, 1500);
                    }
                } else {
                    // Show error message
                    showMessage($container, 'error', response.data.message || 'An error occurred. Please try again.');
                }
            },
            error: function(xhr, status, error) {
                $container.removeClass('submitting');
                $submitBtn.prop('disabled', false).text(originalText);
                showMessage($container, 'error', 'An error occurred. Please try again.');
                console.error('AJAX Error:', error);
            }
        });
    }

    /**
     * Handle comment form submission
     */
    function handleCommentFormSubmit($container) {
        // Collect form data
        const formData = new FormData();
        
        // Get all form inputs
        $container.find('input, select, textarea').each(function() {
            const $field = $(this);
            const name = $field.attr('name');
            if (name) {
                formData.append(name, $field.val());
            }
        });
        
        // Get post ID - try multiple methods
        let postId = $container.find('input[name="comment_post_ID"]').val();
        
        if (!postId) {
            postId = $container.find('input.comment-post-id').val();
        }
        
        if (!postId) {
            // Try to get from hidden field added by FormReplacer
            postId = $container.closest('form').find('input[name="comment_post_ID"]').val();
        }
        
        if (!postId) {
            // Try to get from article ID
            const $article = $('article').first();
            if ($article.length) {
                const articleId = $article.attr('id');
                if (articleId && articleId.indexOf('post-') === 0) {
                    postId = articleId.replace('post-', '');
                }
            }
        }
        
        if (!postId) {
            // Try to get from body class
            const bodyClasses = $('body').attr('class') || '';
            const match = bodyClasses.match(/postid-(\d+)/);
            if (match && match[1]) {
                postId = match[1];
            }
        }
        
        if (!postId) {
            // Try to get from URL
            const urlMatch = window.location.href.match(/[\?&]p=(\d+)/);
            if (urlMatch && urlMatch[1]) {
                postId = urlMatch[1];
            }
        }
        
        // console.log('Comment form - Post ID:', postId);
        
        if (!postId) {
            showMessage($container, 'error', 'Invalid post ID. Please refresh the page and try again.');
            return;
        }
        
        // Add action and post ID
        formData.append('action', 'simpleform_submit_comment');
        formData.append('comment_post_ID', postId);
        formData.append('nonce', front_end_data.nonce);
        
        // Show loading state
        const $submitBtn = $container.find('.submit-button');
        const originalText = $submitBtn.text();
        $submitBtn.prop('disabled', true).text('Submitting...');
        $container.addClass('submitting');
        
        // Submit via AJAX
        $.ajax({
            url: front_end_data.admin_ajax,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                $container.removeClass('submitting');
                $submitBtn.prop('disabled', false).text(originalText);
                
                if (response.success) {
                    // Show success message
                    showMessage($container, 'success', response.data.message || 'Comment submitted successfully!');
                    
                    // Clear form fields
                    $container.find('input[type="text"], input[type="email"], input[type="url"], textarea').val('');
                    
                    // Reload page after 2 seconds to show new comment
                    setTimeout(function() {
                        window.location.reload();
                    }, 2000);
                } else {
                    // Show error message
                    showMessage($container, 'error', response.data.message || 'Failed to submit comment. Please try again.');
                }
            },
            error: function(xhr, status, error) {
                $container.removeClass('submitting');
                $submitBtn.prop('disabled', false).text(originalText);
                showMessage($container, 'error', 'An error occurred. Please try again.');
                console.error('AJAX Error:', error);
            }
        });
    }

    /**
     * Show message to user
     */
    function showMessage($container, type, message) {
        // Remove existing messages
        $container.find('.simpleform-message').remove();
        
        // Create message element
        const $message = $('<div class="simpleform-message ' + type + '">' + message + '</div>');
        
        // Insert message at top of container
        $container.prepend($message);
        
        // Auto-hide after 5 seconds
        setTimeout(function() {
            $message.fadeOut(function() {
                $(this).remove();
            });
        }, 5000);
    }

})(jQuery);
